import { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useRecoilValue } from "recoil";
import { advertisingModalDataState, adActionsState } from "atoms";

function AdvertisingModal({
  show,
  handleClose,
  handleDecision,
}: {
  show: boolean;
  handleClose: () => void;
  handleDecision: (accepted: any) => void;
}) {
  const advertisingModalData = useRecoilValue(advertisingModalDataState);
  const [image, setImage] = useState("");
  const [host, setHost] = useState("");
  const adActions = useRecoilValue(adActionsState);

  const imageRelativePath = "https://dc84iurnf722p.cloudfront.net/ProductCatalog";

  useEffect(() => {
    setHost(window.location.host);
    const setImagePath = () => {
      if (host.includes("ecommerced")) {
        setImage(`${imageRelativePath}/delta/${advertisingModalData.savedFileName}`);
      } else if (host.includes("frontend-dev")) {
        setImage(`${imageRelativePath}/delta/${advertisingModalData.savedFileName}`);
      } else if (host.includes("frontend-qa")) {
        setImage(`${imageRelativePath}/alpha/${advertisingModalData.savedFileName}`);
      } else if (host.includes("frontend-automate")) {
        setImage(`${imageRelativePath}/alpha/${advertisingModalData.savedFileName}`);
      } else {
        setImage(`${imageRelativePath}/prod/${advertisingModalData.savedFileName}`);
      }
    };
    setImagePath();
  }, [advertisingModalData.savedFileName, host]);

  return (
    <Modal show={show} onHide={handleClose} size='lg' contentClassName='no-radius'>
      <Modal.Body className='p-0 no-radius advertising-wifi-modal'>
        <Container className='p-0 overflow-scroll'>
          <Row className='g-0'>
            <Col xs={12} md={6} className='bg-black p-4'>
              <div className='d-flex justify-content-center flex-column p-4 add-wifi-header'>
                <img style={{ height: "100%", width: "100%", marginTop: "-50px" }} src={image} alt='' />
                <div dangerouslySetInnerHTML={{ __html: advertisingModalData?.contentModalLeft }} className='content-modal-left' />
              </div>
            </Col>
            <Col xs={12} md={6} className='p-2'>
              <div className='d-flex justify-content-center flex-column p-4 add-wifi-content'>
                <div dangerouslySetInnerHTML={{ __html: advertisingModalData?.contentModalRightTop }} className='content-modal-right-top' />
                <div className='mb-4 mt-3 add-wifi-buttons-container'>
                  <Button className='m-1 bg-primary text-white' variant='' onClick={() => handleDecision(adActions)}>
                    {advertisingModalData?.buttonAcceptText}
                  </Button>
                  <Button variant='outline-secondary' className='m-1' onClick={() => handleDecision([])}>
                    {advertisingModalData?.buttonDeclineText}
                  </Button>
                </div>
                <div dangerouslySetInnerHTML={{ __html: advertisingModalData?.contentModalRightBottom }} />
              </div>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
}

export default AdvertisingModal;
